import React from 'react';
import RouteLoading from 'Components/RouteLoading';
import useGlobalRules from 'Hooks/query-hooks/global-rules/useGlobalRules';
import useGetListNames from 'Hooks/query-hooks/list/useGetListNames';
import useGetParameters from 'Hooks/query-hooks/parameters/useGetParameters';
import errorController from 'Components/ErrorScreens';
import GlobalRulesLayout from './GlobalRulesLayout';

const GlobalRulesPage = () => {
    const { data: listNameMap, isLoading: listNameMapLoading, isFetching: listNameMapFetching } = useGetListNames();
    const parametersAPI = useGetParameters({
        queryParams: {
            status: JSON.stringify(['active'])
        }
    });
    const globalRules = useGlobalRules({
        listNameMap,
        showDeletedRule: true,
        enable: !listNameMapLoading && !listNameMapFetching && !parametersAPI.isLoading && !parametersAPI.isFetching,
        parameterData: parametersAPI.data
    });

    if (globalRules.isLoading || !globalRules.data) {
        return <RouteLoading />;
    }

    if (globalRules.isError) {
        const { errorCmp } = errorController([globalRules.error]);
        return errorCmp;
    }

    return <GlobalRulesLayout data={globalRules.data} />;
};

export default GlobalRulesPage;
